export const PAGE_ID_HEADER = 'x-page-id';
export const TIMEZONE_HEADER = 'x-timezone';
export const AUTHORIZATION_HEADER = 'Authorization';

export const API_ROUTES_TO_RETRY = [
	// home page
	'/user/me',
	'/inbox/fetch-counts',
	'/form/fetch-for-user',

	// form responses page
	'/form/fetch-details',
	'/form/fetch-composite-ai-queries',
	'/form/fetch-users',
	'/form/fetch-notif-settings',
	'/form/fetch-column-info',
	'/form/fetch-details',
	'/submission/fetch-for-form',

	// form responses page
	'/form/already-filled-by-user',
	'/form/fetch-for-filling',
];

export const ALLOWED_SILENT_API_FAILURES = [
	'/form/trigger-composite-ai-query-suggestions',
	'/submission/autofill-from-resume',
	// An invalid or closed offer link is a page state on the candidate's offer page, not an error.
	'/offer/fetch-for-signing',
];
